import Image from 'snippets/image/image'

function QuizBar() {
  const { title, subTitle, image, ctaText, ctaUrl, isShow } = quizBar

  return (
    isShow &&
    title && (
      <div className='4xl:container'>
        <div className="w-full pb-4 mt-4 px-4 border-b md:mt-8 md:pb-8 md:px-8 4xl:px-0">
          <div className="flex flex-col justify-between gap-4 p-4 border rounded-lg border-primary-500 bg-primary-200 md:flex-row md:p-6">
            <div className="flex items-center gap-4">
              {image && (
                <div className="w-8 h-8 shrink-0 md:h-10 md:w-10">
                  <Image imageUrl={[image]} imageClass="w-full h-full" />
                </div>
              )}
              <div className="flex flex-col gap-0.5">
                <h3 className="font-medium uppercase text-hxs text-grey-900">{title}</h3>
                {subTitle && <p className="text-sm font-light text-grey-900">{subTitle}</p>}
              </div>
            </div>
            {ctaUrl && ctaText && (
              <a href={ctaUrl} className="border-0 button-primary button-small">
                {ctaText}
              </a>
            )}
          </div>
        </div>
      </div>
    )
  )
}

export default QuizBar
